import { useReducer, useEffect } from 'react';
const initialState = {
    eventChange: 1,
    active: false,
    timerId: null,
};

export const useTimeoutFunction = (func, timeLapse) => {
    const [{ eventChange, active, timerId }, dispatch] = useReducer((prev, next) => {
        return { ...prev, ...next };
    }, initialState);

    const generateTimeout = () =>
        dispatch({
            timerId: setTimeout(() => {
                func();
            }, timeLapse),
        });

    useEffect(() => {
        if (active) {
            clearTimeout(timerId);
            generateTimeout();
        } else {
            if (timerId) {
                clearTimeout(timerId);
                dispatch({
                    timerId: null,
                });
            }
        }

        return () => clearTimeout(timerId);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [active, eventChange]);

    const resetTimeoutFunction = () => {
        dispatch({ eventChange: eventChange + 1 });
    };

    const startTimeoutFunction = () => {
        dispatch({ active: true });
    };

    const stopTimeoutFunction = () => {
        dispatch({ active: false });
    };

    return { resetTimeoutFunction, startTimeoutFunction, stopTimeoutFunction };
};
